import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AwsService, SignatoryesService, UsuarioService } from 'src/app/services/service.index';
import swal2 from 'sweetalert2';
import Swal2 from 'sweetalert2';

@Component({
  selector: 'app-investigacion',
  templateUrl: './investigacion.component.html',
  styleUrls: ['./investigacion.component.css']
})
export class InvestigacionComponent implements OnInit {
  @Input() eventEmitter: EventEmitter<Object>;
  @Output() childEvent = new EventEmitter();
  doctor: any;
  info: any;
  customer_credit = '';
  
  doctorFG = new FormGroup({
    average_fee: new FormControl(null),
    cedula: new FormControl(null),
    con_type: new FormControl(null),
    created_at: new FormControl(null),
    detail_extra_incomes: new FormControl(null),
    economic_dependent: new FormControl(null),
    extra1: new FormControl(null),
    extra2: new FormControl(null),
    extra3: new FormControl(null),
    extra_incomes: new FormControl(null),
    family_dependent: new FormControl(null),
    fee: new FormControl(null),
    id: new FormControl(null),
    labor_dependent: new FormControl(null),
    month_patients: new FormControl(null),
    monthly_income: new FormControl(null),
    name: new FormControl(null),
    own_consultory: new FormControl(null),
    payment_rent: new FormControl(null),
    private_address: new FormControl(null),
    rfc: new FormControl(null),
    seniority: new FormControl(null),
    speciality: new FormControl(null),
    surgery_income: new FormControl(null),
    user_id: new FormControl(null),
    user_vendor_id: new FormControl(null),
    office_phone: new FormControl(null),
  });

  investigationFG = new FormGroup({
    hospital_name: new FormControl(''),
    doctor_url: new FormControl(''),
    hospital_review: new FormControl(''),
    office_number: new FormControl(''),
    appointment_availability: new FormControl(''),
    consultation_cost: new FormControl(''),
    ine_validation: new FormControl(false),
    professional_id_validation: new FormControl(false),
    blacklists_validation: new FormControl(false),
    references_validation: new FormControl(false),
    address_validation: new FormControl(''),
    doctor_picture: new FormControl(''),
    address_picture1: new FormControl(''),
    address_picture2: new FormControl(''),
    address_picture3: new FormControl(''),
    address_picture4: new FormControl(''),
    extra1: new FormControl(''),
    extra2: new FormControl(''),
    extra3: new FormControl(''),
    customer_credit_id: new FormControl(this.customer_credit),
    user_id: new FormControl(localStorage.getItem('uid')),
    private_address: new FormControl(''),
  });

  addressFG = new FormGroup({
    address_reference: new FormControl(''),
    address_type: new FormControl(''),
    apartment_number: new FormControl(''),
    contributor_id: new FormControl(''),
    created_at: new FormControl(''),
    external_number: new FormControl(''),
    id: new FormControl(''),
    municipality: new FormControl(''),
    municipality_id: new FormControl(''),
    postal_code: new FormControl(''),
    state: new FormControl(''),
    state_id: new FormControl(''),
    street: new FormControl(''),
    suburb: new FormControl(''),
    suburb_type: new FormControl(''),
    updated_at: new FormControl(''),
  });
  documentos = [];
  ine = {
    created_at: '',
    extra1: '',
    extra2: '',
    extra3: '',
    file_type_document_id: '',
    id: '',
    name: '',
    notes: '',
    status: '',
    updated_at: '',
    url: '',
    user_id: '',
  };
  cedula = {
    created_at: '',
    extra1: '',
    extra2: '',
    extra3: '',
    file_type_document_id: '',
    id: '',
    name: '',
    notes: '',
    status: '',
    updated_at: '',
    url: '',
    user_id: '',
  };
  listas = {
    created_at: '',
    extra1: '',
    extra2: '',
    extra3: '',
    file_type_document_id: '',
    id: '',
    name: '',
    notes: '',
    status: '',
    updated_at: '',
    url: '',
    user_id: '',
  };
  panelPersonales = false;
  investigacionPrevia = false;
  idInvestigation = '';
  firmaInvestigacion: any;
  token: any;
  ccid: any;
  contributor_addresses: any;
  investigacion = [];
  customer: any;
  person: any;
  comite = false;
  quote: any;

  constructor(private usuarioService: UsuarioService,
              private awsService: AwsService,
              private sygnatoryesService: SignatoryesService,
              private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    this.ccid = this.route.snapshot.paramMap.get('ccid');
    if( this.route.snapshot.paramMap.get('token') && this.route.snapshot.paramMap.get('ccid') ){
      this.comite = true;
      this.subscribeToEndpoint();
    }else{
      console.log('Desde componente padre');
      this.subscribeToParentEmitter();
    }
  }

  subscribeToEndpoint(){
    this.sygnatoryesService.getDataComite().pipe(filter(data => data !== null)).subscribe( resp => {
      // aqui checar si tiene object.keys o es un array directo
      this.investigacion = resp['investigacion']? resp['investigacion'] : [];
      this.customer = resp['customer'];
      this.quote = resp['quote'];
      this.doctor = this.quote.user_customer?.doctors[0];
      this.person = this.customer['contributor']['person'];
      this.contributor_addresses = this.customer.contributor.contributor_addresses;
      this.armaInvestigacion();
    });
    /* this.sygnatoryesService.getInvestigationNoLogin(this.ccid).subscribe( resp => {
      this.investigacion = resp['investigation'];
      this.customer = resp[0]['customer'];
      this.doctor = resp[0]['quote'].user_customer?.doctors[0];
      this.person = this.customer['contributor']['person'];
      this.contributor_addresses = this.customer.contributor.contributor_addresses;
      // docs['data'].forEach(doc => {
      //   this.documentos.push(doc['attributes'])
      // })
      // this.ine = this.documentos.find(doc => doc['name']?.toLowerCase().includes('ine'));
      // this.cedula = this.documentos.find(doc => doc['name']?.toLowerCase().includes('profesional'));
      // this.listas = this.documentos.find(doc => doc['name']?.toLowerCase().includes('listas'));
      this.armaInvestigacion();
    }) */
  }

  subscribeToParentEmitter(): void { 
    this.eventEmitter.subscribe(rowData => {
      this.customer_credit = rowData.id;
      var observableDoctor = this.usuarioService.getUserDoctor(rowData['quote']['user_customer_id']);
      var observableInfo = this.usuarioService.getInfoById(rowData['quote']['user_customer_id']);
      var observableInvestigation = this.usuarioService.getInvestigation(this.customer_credit);
      var observableDocumentos = this.usuarioService.getUserDocuments(rowData['quote']['user_customer_id']);
      forkJoin([observableDoctor, observableInfo, observableInvestigation, observableDocumentos]).subscribe(([doctor, info, investigacion, docs]) => {
        this.doctor = doctor[0];
        this.info = info[0];
        this.person = info?.customers[0].contributor.person;
        this.customer = this.info.customers[0];
        docs['data'].forEach(doc => {
          this.documentos.push(doc['attributes'])
        })
        this.ine = this.documentos.find(doc => doc['name']?.toLowerCase().includes('ine'));
        this.cedula = this.documentos.find(doc => doc['name']?.toLowerCase().includes('profesional'));
        this.listas = this.documentos.find(doc => doc['name']?.toLowerCase().includes('listas'));
        this.investigacion = investigacion;
        this.contributor_addresses = this.customer.contributor.contributor_addresses;

        this.armaInvestigacion();
      })
    })
  }

  armaInvestigacion(){
    this.investigationFG.patchValue({consultation_cost: this.doctor.fee});
        Object.keys(this.doctor).forEach(k => {
          this.doctorFG.patchValue({[k]: this.doctor[k]});
        });
        if( this.investigacion?.length > 0){
          this.investigacionPrevia = true;
          Object.keys(this.investigacion[0]).forEach(k => {
            this.investigationFG.patchValue({[k]: this.investigacion[0][k]});
          });
          this.idInvestigation = this.investigacion[0].id;
          this.firmaInvestigacion = this.investigacion[0].user;
        }
        Object.keys(this.contributor_addresses[0]).forEach(k => {
          this.addressFG.patchValue({[k]: this.contributor_addresses[0][k]});
        });
        this.addressFG.patchValue({state: this.contributor_addresses[0].state.name});
        this.addressFG.patchValue({municipality: this.contributor_addresses[0].municipality.name});
  }

  cerrar(){
    this.childEvent.emit({message: 'cerrarcreausr'})
  }

  isEmpty(controlName: string): boolean {
    const value = this.investigationFG.get(controlName)?.value;
    return value === null || value === '';
  }

  mostrarImagen(src){
    Swal2.fire({
      imageUrl: src,
      imageAlt: 'Imagen',
      showCloseButton: true,
      // background: '#000', // opcional para destacar la imagen
      width: 'auto', // permite que el modal se ajuste al contenido
      customClass: {
        image: 'imagen-modal-swal'
      }
    });
  }

  async fileBrowseHandler( event: any, doc: string ) {
    const file: File = event.target.files[0];

    const imgExtensiones = [
      'image/png',
      'image/jpeg',
      'image/jpg',
      'image/gif',
      'image/webp',
      'image/bmp',
      'image/svg+xml'
    ];

    if (file && !imgExtensiones.includes(file.type)) {
      swal2.fire('Atención', 'Solo se permiten imágenes (PNG, JPG, JPEG, etc.)', 'info');
      event.target.value = '';
      return;
    }

    await this.callupload(file, doc, this.customer_credit);
  }

  async callupload(file, doc, credito) {
    try {
      const r = await this.awsService.uploadFileSBImages(file, credito);

      this.investigationFG.patchValue({[doc]: r['url']});

    } catch (error) {
      console.log('error', error);
      let resp = {
        status: false,
        resp: error,
        msg: 'Fallo al subir archivo'
      }
      try{
        swal2.fire(error.error.error, error.error.exception, 'info');
      }catch{
        swal2.fire('Error', 'Ocurrió algo en la carga', 'info')
      }
      return resp
    }
  }

  dragEnter(id: string) {
    document.getElementById(id).style.border = "dashed 3px #73CB38";
  }
  dragLeave(id: string) {
    document.getElementById(id).style.border = "dashed 1px #979797";
  }
  drop(id: string) {
    document.getElementById(id).style.border = "dashed 1px #979797";
  }

  validarEntrada(event: KeyboardEvent) {
    const char = event.key;
  
    // Permitir números y solo un punto
    const esNumero = /[0-9]/.test(char);
    const esPunto = char === '.';
    const yaTienePunto = (event.target as HTMLTextAreaElement).value.includes('.');
  
    if (!esNumero && (!esPunto || yaTienePunto)) {
      event.preventDefault();
    }
  }

  downloadImage(url: string, nombre: string) {
    const img = new Image();
    // img.crossOrigin = 'Anonymous'; // necesario si CORS estuviera permitido

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      ctx.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL('image/jpeg');
      const enlace = document.createElement('a');
      enlace.href = dataURL;
      enlace.download = nombre + '.jpg';
      enlace.click();
    };

    img.src = url;
  }

  guardarInvestigacion(){
    var params = {};
    var credit_investigation = this.investigationFG.value;
    credit_investigation['customer_credit_id'] = this.customer_credit;
    params['credit_investigation'] = credit_investigation;
    console.log('Guardando investigacion', params);
    if (this.investigacionPrevia) {
      this.usuarioService.actualizaInvestigacion(this.idInvestigation, params).subscribe(resp => {
        console.log(resp);
        swal2.fire('Éxito', 'Investigación guardada correctamente', 'success');
        this.cerrar();
      }, err => {
        console.log(err);
        swal2.fire('Error', 'Ocurrió un error al actualizar la investigación', 'error');
      })
    }else{
      this.usuarioService.crearInvestigacion(params).subscribe(resp => {
        swal2.fire('Éxito', 'Investigación guardada correctamente', 'success');
        this.cerrar();
      }, err => {
        console.log(err);
        swal2.fire('Error', 'Ocurrió un error al guardar la investigación', 'error');
      })
    }
  }

}
